import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ISession } from 'modules/video-conference/interfaces/session.interface';
import { Observable } from 'rxjs';

@Injectable()
export class SessionService {
	constructor(private httpClient: HttpClient) {}

	public getData(appointmentId: string): Observable<ISession> {
		return this.httpClient.get<ISession>(`contacts/session/${appointmentId}`);
	}
}
